<template>
  <n-modal-provider>
    <n-config-provider :theme="currTheme" :theme-overrides="themeOverride">
      <n-message-provider>
        <n-theme-editor v-if="devThemeEditor" :theme="currTheme">
          <slot />
        </n-theme-editor>
        <slot v-else />
      </n-message-provider>
    </n-config-provider>
  </n-modal-provider>
  <!-- v8 ignore next - devtools only rendered in development -->
  <VueQueryDevtools v-if="devVueQuery" buttonPosition="bottom-left" />
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import {
  NConfigProvider,
  NModalProvider,
  NMessageProvider,
  NThemeEditor,
  darkTheme,
  useOsTheme,
} from 'naive-ui'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'

import { themeOverrides } from '@/configs/themes.js'

const devMode = import.meta.env.DEV

// Dev plugins toggle flags, only active in dev mode
const devVueQuery = ref(false)
const devThemeEditor = ref(false)

const osThemeRef = useOsTheme()

const currTheme = computed(() => (osThemeRef.value === 'dark' ? darkTheme : null))
const themeOverride = computed(() =>
  osThemeRef.value === 'dark' ? themeOverrides.dark : themeOverrides.light,
)

function handleDevPluginShortcut(e) {
  // Only enable in dev mode
  if (!devMode) return

  // Toggle VueQueryDevtools: Ctrl + Shift + Q
  if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'q') {
    devVueQuery.value = !devVueQuery.value
  }

  // Toggle NThemeEditor: Ctrl + Shift + T
  if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 't') {
    devThemeEditor.value = !devThemeEditor.value
  }
}

onMounted(() => {
  if (devMode) {
    window.addEventListener('keydown', handleDevPluginShortcut)
  }
})

onUnmounted(() => {
  if (devMode) {
    window.removeEventListener('keydown', handleDevPluginShortcut)
  }
})
</script>
